export type DiscussionMentionData = {
    userId: string;
    name: string;
};

export type DiscussionMentionEvent = CustomEventInit<DiscussionMentionData>;

////////////////////////////////////////////////////////////////////////////////

export function publishDiscussionMentionEvent(data: DiscussionMentionData) {
    const event = new CustomEvent("discussionMention", { detail: data });
    document.dispatchEvent(event);
}
export function subscribeDiscussionMentionEvent(listener: (e: DiscussionMentionEvent) => void) {
    document.addEventListener("discussionMention", listener);
}
export function unsubscribeDiscussionMentionEvent(listener: (e: DiscussionMentionEvent) => void) {
    document.addEventListener("discussionMention", listener);
}

////////////////////////////////////////////////////////////////////////////////
